import React, { useState, useEffect } from "react";
import "./styles.css";

import moment from "moment";
import Filter from "../FilterProductosNegocios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "@ant-design/plots";
import {
  DatePicker,
  Space,
  Card,
  Col,
  Row,
  Typography,
  Statistic,
  Table,
} from "antd";
import CountUp from "react-countup";
const { Text } = Typography;

const { RangePicker } = DatePicker;
const formatter = (value) => <CountUp end={value} separator="," />;

ChartJS.register(ArcElement, Tooltip, Legend);

const configAxios = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
};

const data2 = [
  {
    type: "Chipa",
    value: 27,
  },
  {
    type: "Facturas y Medialunas",
    value: 25,
  },
  {
    type: "Bizcochitos de Manteca y Queso",
    value: 18,
  },
  {
    type: "Sandwich",
    value: 15,
  },
  {
    type: "Pepas, Brownies, Cookies",
    value: 10,
  },
  {
    type: "Jugos y Liquados",
    value: 5,
  },
];

const configPie = {
  appendPadding: 20,
  data: data2,
  angleField: "value",
  colorField: "type",
  radius: 0.6,
  legend: false,
  label: {
    type: "spider",
    labelHeight: 28,
    content: "{name}\n{percentage}",
  },
  interactions: [
    {
      type: "element-selected",
    },
    {
      type: "element-active",
    },
  ],
};

const columns = [
  {
    title: "Producto",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Cantidad",
    dataIndex: "Qty",
    key: "Qty",
  },
  {
    title: "Total",
    dataIndex: "Total",
    key: "Total",
    // render: (_, products) => {
    //   // return formatter(products.map((e) => e));
    // },
  },
];

function Productos() {
  const [products, setProducts] = useState();
  const [data, setData] = useState();

  const [from, setFrom] = useState(
    `'${moment().startOf("month").format("YYYY-MM-DD")}'`
  );
  const [to, setTo] = useState(`'${moment().format("YYYY-MM-DD")}'`);

  console.log("data", data);
  console.log("products", products);

  const handleDate = (value) => {
    // console.log("value", value);
    if (value !== null) {
      setFrom(`'${moment(value[0]._d).format().split("T")[0]}'`);
      setTo(`'${moment(value[1]._d).format().split("T")[0]}'`);
    } else {
      //   props.setData("");
    }
    console.log(`data in the products negocios, ${products[0].Name} `);
  };

  return (
    <div>
      <div className="datepicker-container">
        <Filter setData={setData} setProducts={setProducts} />
        <Text className="dd2">
          Desde {moment(from).format("dddd DD")} Hasta{" "}
          {moment(to).format("dddd DD")}
        </Text>
      </div>

      <Row gutter={16}>
        {data &&
          data.map((e) => {
            if (e.name) {
              return (
                <Col span={5}>
                  <Row>
                    <Card title={e.name} bordered={true}>
                      <div className="table-products">
                        <Table
                          dataSource={e.data}
                          columns={columns}
                          rowKey="Name"
                        />
                      </div>
                    </Card>
                  </Row>
                </Col>
              );
            }
          })}
      </Row>

      {products &&
        products.map((e, i) => {
          console.log(e.name);
          console.log("posicion", i);
          return (
            <div className="table-products">
              <Table dataSource={e.data} columns={columns} rowKey="Name" />
            </div>
          );
        })}

      <Row>
        <Col span={5}>
          <Card title="Panificados" bordered={true}>
            DATA
          </Card>
        </Col>
        <Col span={5}>
          <Card title="Cafe" bordered={true}>
            Calculation
          </Card>
        </Col>
        <Col span={5}>
          <Card title="Jugos y Liquados" bordered={true}>
            Calculation
          </Card>
        </Col>
      </Row>

      <Col span={22}>
        <Pie {...configPie} autoFit={true} />
      </Col>
    </div>
  );
}

export default Productos;
